@let summaryBasicInfoValue = summaryBasicInfo();
@let isHiddenValue = isHidden();

<div class="wrapper" layout layout-space-between margin-top>
  <rt-candidate-skills-chart
    [skills]="summaryBasicInfoValue"
    [isHidden]="isHiddenValue"
    [theme]="theme()"
    margin-left-large
  />

  <div
    [class.four-columns]="summaryBasicInfoValue.noEvaluatedSkills.length"
    [class.three-columns]="!summaryBasicInfoValue.noEvaluatedSkills.length"
    class="columns-container"
    layout
    layout-align-items-center
    min-width-0
  >
    <div class="columns-wrapper" padding-left min-width-0>
      <ng-container
        [ngTemplateOutlet]="columnTemplate"
        [ngTemplateOutletContext]="{
          status: SkillDetailsStatus.AboveRequiredLevel,
          statusLabel:
            'app.interview.summary.skills_summary.status.above_required_level' | translate,
          skills: summaryBasicInfoValue.aboveRequiredLevelSkills,
          isLast: false,
        }"
      />

      <ng-container
        [ngTemplateOutlet]="columnTemplate"
        [ngTemplateOutletContext]="{
          status: SkillDetailsStatus.AtRequiredLevel,
          statusLabel:
            'app.interview.summary.skills_summary.status.at_required_level_full' | translate,
          skills: summaryBasicInfoValue.atRequiredLevelSkills,
          isLast: false,
        }"
      />

      <ng-container
        [ngTemplateOutlet]="columnTemplate"
        [ngTemplateOutletContext]="{
          status: SkillDetailsStatus.BelowRequiredLevel,
          statusLabel:
            'app.interview.summary.skills_summary.status.below_required_level' | translate,
          skills: summaryBasicInfoValue.belowRequiredLevelSkills,
          isLast: !summaryBasicInfoValue.noEvaluatedSkills.length,
        }"
      />

      @if (summaryBasicInfoValue.noEvaluatedSkills.length) {
        <ng-container
          [ngTemplateOutlet]="columnTemplate"
          [ngTemplateOutletContext]="{
            status: SkillDetailsStatus.NoEvaluated,
            statusLabel: 'app.interview.summary.skills_summary.status.not_evaluated' | translate,
            skills: summaryBasicInfoValue.noEvaluatedSkills,
            isLast: true,
          }"
        />
      }
    </div>
  </div>
</div>

@let noRequiredLevelSkillsCount = summaryBasicInfoValue.noRequiredLevelSkills.length;
@if (noRequiredLevelSkillsCount) {
  <rt-infobox
    [type]="'transparent'"
    [iconName]="'info-outline'"
    [isDismissible]="false"
    [messagePaddingSmall]="true"
    margin-top
  >
    <div layout>
      <span
        [innerHTML]="
          (noRequiredLevelSkillsCount === 1
            ? 'app.interview.summary.skills_summary.no_required_level_infobox.content_one'
            : 'app.interview.summary.skills_summary.no_required_level_infobox.content_other'
          ) | translate: { count: noRequiredLevelSkillsCount }
        "
      ></span>
    </div>
  </rt-infobox>
}

<ng-template #hiddenContent>
  <span text-disabled>∗∗∗</span>
</ng-template>

<ng-template #skillBadgeTemplate let-skill="skill">
  <rt-badge
    [color]="'counter-light'"
    [contentTpl]="badgeTemplate"
    [rtTooltip]="skill.name"
    [rtTooltipEnableWhenTruncated]="true"
    class="transform-none badge"
    margin-right-small-xx
    margin-bottom-small-xx
  />
  <ng-template #badgeTemplate>
    <span>{{ skill.name }}</span>
  </ng-template>
</ng-template>

<ng-template
  #columnTemplate
  let-status="status"
  let-statusLabel="statusLabel"
  let-skills="skills"
  let-isLast="isLast"
>
  <div class="column" layout>
    <div layout layout-flex-1 margin-bottom>
      <div layout margin-right-small-x margin-top-small-xx>
        <span
          [class.is-hidden]="isHiddenValue"
          [class.above-required-level]="status === SkillDetailsStatus.AboveRequiredLevel"
          [class.at-required-level]="status === SkillDetailsStatus.AtRequiredLevel"
          [class.below-required-level]="status === SkillDetailsStatus.BelowRequiredLevel"
          [class.no-evaluated]="status === SkillDetailsStatus.NoEvaluated"
          class="skill-leaf"
        ></span>
      </div>
      <div layout-vertical min-width-0>
        <div layout layout-align-items-start margin-bottom-small-xxx>
          @if (!isHiddenValue) {
            <span text-large text-darkest text-bold margin-right-small-xx>{{ skills.length }}</span>
          } @else {
            <div class="icon-container" layout margin-right-small-xx>
              <rt-icon
                size="small"
                name="visibility-off"
                colorToken="colorIconDisabled"
                margin-right-small-xx
              />
            </div>
          }

          <span>{{ statusLabel }}</span>
        </div>
        <div layout layout-wrap>
          @if (!isHiddenValue) {
            @for (skill of skills; track skill.id) {
              <ng-container
                [ngTemplateOutlet]="skillBadgeTemplate"
                [ngTemplateOutletContext]="{ skill }"
              />
            }
            @if (!skills.length) {
              <span>-</span>
            }
          } @else {
            <rt-badge
              [color]="'counter-light'"
              [contentTpl]="hiddenContent"
              class="transform-none"
              margin-right-small-xx
              margin-bottom-small-xx
            />
          }
        </div>
      </div>
    </div>
    @if (!isLast) {
      <div layout margin-lr padding-tb-small-x>
        <div class="custom-divider"></div>
      </div>
    }
  </div>
</ng-template>
